import React, { useState, useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import { useAuth } from '../../../../context/AuthContext';
import SystemLoadingOverlay from './SystemLoadingOverlay';

const READY_MESSAGE_TYPES = [
  'TRELLOHIT_READY',
  'ACADEMY_READY',
  'CRM_READY',
  'BOLSA_READY',
  'SCRAPPING_READY',
  'SYSTEM_READY',
];

const ExternalSystemHandshake = ({ system, activationData, onLoaded }) => {
  const { user } = useAuth();
  const [isReady, setIsReady] = useState(false);
  const readyReceivedRef = useRef(false);
  const notifiedRef = useRef(false);

  const onLoadedRef = useRef();
  useEffect(() => {
    onLoadedRef.current = onLoaded;
  });

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type && READY_MESSAGE_TYPES.includes(event.data.type) && !readyReceivedRef.current) {
        readyReceivedRef.current = true;
        setIsReady(true);
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  useEffect(() => {
    if (isReady && !notifiedRef.current) {
      notifiedRef.current = true;
      onLoadedRef.current?.();
    }
  }, [isReady]);

  return (
    <Box sx={{ width: "100%", height: "100%", position: "relative" }}>
      {!isReady && (
        <SystemLoadingOverlay
          title={`Cargando ${system.title}`}
          subtitle="Sincronizando tu sesión y contenido..."
          color={system.color || "#6C4DE2"}
        />
      )}
      <iframe
        key={`${system.id}-${activationData?.timestamp || 0}`}
        src={activationData?.initialUrl}
        title={system.title}
        allow="clipboard-write; fullscreen"
        onLoad={() => {
          setTimeout(() => {
            if (!readyReceivedRef.current) {
              readyReceivedRef.current = true;
              setIsReady(true);
            }
          }, 8000);
        }}
        style={{
          border: "none",
          width: "100%",
          height: "100%",
          display: "block"
        }}
      />
    </Box>
  );
};

export default ExternalSystemHandshake;
